
    import './styles.scoped.css';
    export default {
  "content-wrapper": "awsui_content-wrapper_zycdx_s6r07_93",
  "content-wrapper-mobile": "awsui_content-wrapper-mobile_zycdx_s6r07_97"
};
  